import React from 'react';
import PropTypes from 'prop-types';

import { Overlay, OverlayLayer } from '../design/css';

const Loading = ({ children, isVisible }) => {
  const overlayStyle = { display: isVisible ? 'block' : 'none' };
  return (
    <>
      <OverlayLayer style={overlayStyle} />
      <Overlay style={overlayStyle}>{children}</Overlay>
    </>
  );
};

Loading.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired
};

export default Loading;
